export default "__VITE_ASSET__1d02d39a__"